export enum AssociationFeatureFlagEnum {
  HIDE_COACH_CLASS = "HIDE_COACH_CLASS",
  CARD_VALID_WITHOUT_IMAGE = "CARD_VALID_WITHOUT_IMAGE",
}
